import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type Necklace4IconProps = CreateIconComponentProps;
export const Necklace4Icon: React.FC<Necklace4IconProps> = ({
  title = 'Necklace4',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <circle
      cx="12.469"
      cy="19.343"
      r="2.344"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle
      cx="8.25"
      cy="17.938"
      r="1.875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle
      cx="16.688"
      cy="17.938"
      r="1.875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle
      cx="18.094"
      cy="14.656"
      r="1.406"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle
      cx="5.906"
      cy="14.656"
      r="1.406"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4.5 9.059V9.03m0 0C4.516 5.145 7.868 2 12 2c4.142 0 7.5 3.16 7.5 7.059 0 1.884-.219 3.035-.445 3.722M4.5 9.031c-.007 1.875.227 3.047.463 3.75"
    />
  </CreateIconComponent>
);
